import { z } from 'zod';
import { gtmItemResource } from '@/api/resources';

export const gtmStateSchema = z.object({
	resort: z.string().optional(),
	last_items: z.array(gtmItemResource),
});

export type GTMState = z.infer<typeof gtmStateSchema>;
export type GtmItem = z.infer<typeof gtmItemResource>;
